import { getHexColor, OneColorIconProps } from '../utils'

export const MusicIcon: React.FC<OneColorIconProps> = ({ className, color = 'black', size = 64 }) => {
  const hex = getHexColor(color)

  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill={hex}
        d="M56 11.5v38.33c0 5.522-4.477 10-10 10s-10-4.478-10-10c0-5.524 4.477-10 10-10 1.045 0 2.053.16 3 .457v-23.13l-21-4.5V43.33h-.013c-.26 5.29-4.632 9.5-9.987 9.5-5.523 0-10-4.477-10-10s4.477-10 10-10c1.045 0 2.053.16 3 .458V4z"
      />
    </svg>
  )
}
